    import { motion } from 'framer-motion';
    import { ArrowRight } from 'lucide-react';

    import { Button } from '../ui/button';

    export const CTASection = ({ onRequestDemo, onBookTrainingSlot }) => {
      return (
        <section
          className="relative px-4 sm:px-6 py-16 sm:py-24 lg:py-40 bg-gradient-to-b from-[#F8FAFC] via-white to-white overflow-hidden"
          data-testid="cta-section"
        >
          {/* Subtle background decoration */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-1/3 left-1/4 w-[500px] h-[500px] bg-blue-50/50 rounded-full blur-3xl" />
            <div className="absolute bottom-1/3 right-1/4 w-[500px] h-[500px] bg-slate-100/50 rounded-full blur-3xl" />
          </div>

          <div className="relative z-10 text-center max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.7, ease: 'easeOut' }}
            >
              {/* Badge */}
              <span className="inline-block px-4 sm:px-5 py-2 rounded-full bg-brand/5 text-brand text-xs sm:text-sm font-medium mb-6 sm:mb-8 border border-brand/10">
                Ready to transform your classroom?
              </span>

              {/* Heading */}
              <h2 className="font-heading text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-brand mb-6 sm:mb-8 leading-[1.1] tracking-tight">
                Upgrade your classroom whiteboard
              </h2>

              {/* Description */}
              <p className="text-base sm:text-xl md:text-2xl text-slate-500 mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed">
                Join thousands of educators already using intelligent whiteboard technology to enhance student learning.
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
              <Button
                  variant="outline"
                  className="w-full sm:w-auto rounded-lg px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-medium border-2 border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-slate-300 transition-all duration-200"
                  data-testid="cta-learn-more-btn"
                  onClick={onBookTrainingSlot}
                >
                  Book a Training Slot
                </Button>
                <Button
                  onClick={onRequestDemo}
                  className="w-full sm:w-auto bg-brand hover:bg-brand-hover text-white rounded-lg px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-medium transition-all duration-200 hover:scale-[1.02] shadow-lg hover:shadow-xl group"
                  data-testid="cta-request-demo-btn"
                >
                  Request a Demo
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </motion.div>

          </div>
        </section>
      );
    };

    export default CTASection;

